import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import PrivateContent from 'app/common/PrivateContent';
import Icon from 'app/components/Icon';
import logoIcon from 'app/icons/logo.svg';
import arrowIcon from 'app/icons/arrow.svg';
import curvedLine from 'app/icons/curved_line.svg';

import style from './style.scss';

const NotFound: FC = () => {
  const [t] = useTranslation();

  return (
    <div className={style.container}>
      <div className={style.left}>
        <Icon href={logoIcon} className={style.logo} />
        <div className={style.codeMarginTop} />
        <div className={style.code}>{t('not_found-code')}</div>
        <div className={style.description}>{t('not_found-title')}</div>
        <div className={style.solution}>{t('not_found-try_this')}</div>
        <Link to="/" className={style.link}>
          <Icon href={arrowIcon} className={style.arrow} />
          {t('not_found-schedule')}
        </Link>
        <PrivateContent feature="BLUEPRINTS">
          <Link to="/blueprints" className={style.link}>
            <Icon href={arrowIcon} className={style.arrow} />
            {t('not_found-go_blueprints')}
          </Link>
        </PrivateContent>
      </div>
      <div className={style.right}>
        <Icon href={curvedLine} className={style.bottomLeftLine} />
        <Icon href={curvedLine} className={style.topRightLine} />
      </div>
    </div>
  );
};

NotFound.displayName = 'NotFound';

export default NotFound;
